import React, { useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import { Modal } from "../../../../components";
import { Popover } from "react-tiny-popover";
import { Select } from "antd";
import { useStore } from "../../../../stores";
import firebase from "../../../../services/firebase";
import { Event } from "../../../../models";
import locale from "../../../../constants/locale";
import { useTranslation } from "react-i18next";

export default function EventIframe({
  position,
  isResponsive,
}: {
  position: string;
  isResponsive?: boolean;
}) {
  const { t } = useTranslation();
  const { selectedWorkspace } = useStore("workspaces");
  const { selectedChat } = useStore("chats");
  const [isAIPopoverOpen, setIsAIPopoverOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const onSelect = useCallback((value: string) => {
    setSelectedEvent(value);
    setIsAIPopoverOpen(false);
    setIsOpen(true);
  }, []);

  const getEvents = useCallback(async () => {
    if (!selectedWorkspace) {
      return;
    }
    setLoading(true);

    try {
      let snapshot = await firebase
        .firestore()
        .collection("workspaces")
        .doc(selectedWorkspace.id)
        .collection("events")
        .get();

      const data = snapshot.docs.map((doc) => {
        const obj = doc.data() as Event;
        obj.id = doc.id;
        return obj;
      }) as Event[];

      setEvents(data.filter((f) => f.isActive && !f.isArchived));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [selectedWorkspace]);

  useEffect(() => {
    if (isAIPopoverOpen) {
      getEvents();
    }
  }, [getEvents, isAIPopoverOpen]);

  return (
    <>
      {selectedEvent && isOpen && (
        <Modal isOpen isLargeXLScreen onClose={() => setIsOpen(false)}>
          <iframe
            width="100%"
            height="100%"
            seamless={true}
            allowFullScreen={true}
            src={`/booking/${
              selectedWorkspace?.id
            }/${selectedEvent}?iframe=true&chatId=${
              selectedChat?.id
            }&senderId=${encodeURIComponent(selectedChat?.data?.fb_id ?? "")}`}
            title="Booking"
          />
        </Modal>
      )}

      <Popover
        isOpen={isAIPopoverOpen}
        positions={
          position === "composer" ? ["top", "right"] : ["bottom", "left"]
        }
        align={position === "composer" ? "start" : "end"}
        containerStyle={{ zIndex: "100000000" }}
        padding={7}
        onClickOutside={() => setIsAIPopoverOpen(false)}
        content={() => (
          <div className="has-border has-background-white has-rounded-corners p-3">
            <Select
              placeholder={t(locale.event)}
              loading={loading}
              showSearch
              filterOption={(input: any, option: any) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              className={"is-small"}
              size="small"
              allowClear
              style={{ width: 150 }}
              options={events}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onSelect}
            />
          </div>
        )}
      >
        <button
          className={clsx("button has-text-primary", {
            "is-ghost is-no-box-shadow": position === "composer",
            "is-rounded": position === "header" && !isResponsive,
            "is-ghost no-focus": position === "header" && isResponsive,
          })}
          onClick={() => setIsAIPopoverOpen(true)}
        >
          <span style={{ position: "absolute" }} className="icon">
            <img src="/assets/calendar.svg" alt="" />
          </span>
        </button>
      </Popover>
    </>
  );
}
